import React, { ComponentType, JSX } from 'react';
import { theme } from '../../theme';
import { ThemeProvider } from '../../hooks/jss';

export const withTheme = () => (WrappedComponent: ComponentType<unknown>) => {
  const Wrapper = (props: unknown & JSX.IntrinsicAttributes) => {
    return (
      <ThemeProvider theme={theme}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    );
  };

  Wrapper.getInitialProps = async (data: unknown) => {
    return 'getInitialProps' in WrappedComponent &&
      typeof WrappedComponent.getInitialProps === 'function'
      ? await WrappedComponent.getInitialProps(data)
      : {};
  };

  return Wrapper;
};
